import { COULEURS_ADEQUATION, LIBELLES_ADEQUATION, type Adequation as Verdict } from '@rh/shared';

export function BadgeAdequation({ valeur }: { valeur: Verdict | null }) {
  const cle = valeur ?? 'a_evaluer';
  return (
    <span className="badge" style={{ borderColor: COULEURS_ADEQUATION[cle], color: COULEURS_ADEQUATION[cle] }}>
      {LIBELLES_ADEQUATION[cle]}
    </span>
  );
}
